import { getSizeData } from '../../helpers/ResizeData';
import { scrollToTop } from '../../helpers/Scroll';
import { TweenMax, Power1 } from 'gsap';
import { SIZE } from '../../settings/constants';

export default class WelcomeScreen {
  screenWrap = document.getElementById('start-screen');
  bg = document.getElementById('start-bg');
  progressBar = document.getElementById('start-progress');
  progressFill = document.getElementById('start-progress-fill');
  startBtn = document.getElementById('btn-start');

  onStart: () => void;

  complete = false;

  constructor(onStart: () => void) {
    // vars
    this.onStart = onStart;

    // btn
    if (this.startBtn) {
      this.startBtn.addEventListener('click', () => {
        this.startCall();
      });
    }

    // resize
    this.initResize();

    // init scroll
    setTimeout(() => {
      scrollToTop();
    }, 1500);
  }

  // --------------------------------------------------------------
  // Resize
  // --------------------------------------------------------------

  initResize(): void {
    window.addEventListener('resize', this.resizeUpdate.bind(this));
    // init update
    this.resizeUpdate();
    // delayed resizes - mainly because of iOS delay
    setTimeout(() => {
      this.resizeUpdate();
    }, 500);
    setTimeout(() => {
      this.resizeUpdate();
    }, 1500);
  }

  resizeUpdate(): void {
    if (!this.complete) {
      const sizeData = getSizeData();
      if (this.screenWrap) {
        this.screenWrap.style.display = 'block';
        this.screenWrap.style.height = `${sizeData.window.height}px`;
      }
      if (this.bg) {
        const bgW = SIZE.W * sizeData.stage.scale;
        const bgH = SIZE.H * sizeData.stage.scale;
        this.bg.style.width = `${bgW}px`;
        this.bg.style.height = `${bgH}px`;
        this.bg.style.top = `${(sizeData.window.height - bgH) * 0.5}px`;
        this.bg.style.left = `${(sizeData.window.width - bgW) * 0.5}px`;
      }
    }
  }

  // --------------------------------------------------------------
  // Start
  // --------------------------------------------------------------

  startCall(): void {
    if (!this.complete) {
      this.complete = true;

      // hide
      if (this.screenWrap) {
        this.screenWrap.style.display = 'none';
      }

      setTimeout(() => {
        scrollToTop();
      }, 500);
      this.onStart();
    }
  }

  // --------------------------------------------------------------
  // Loader
  // --------------------------------------------------------------

  loaderProgress(value: number): void {
    if (this.progressFill) {
      this.progressFill.style.width = `${Math.min(1, Math.max(0, value)) * 100}%`;
    }
  }

  loadingComplete(): void {
    if (this.progressBar) {
      this.progressBar.style.display = 'none';
    }
    if (this.startBtn) {
      this.startBtn.style.display = 'block';
      this.startBtn.style.opacity = '0';
      TweenMax.to(this.startBtn, 0.4, { opacity: 1, ease: Power1.easeInOut });
    }
  }
}
